export default __webpack_public_path__ + "app/views/administration/accountGroups/overview.html";